

























import Vue from 'vue';
import { fractionOf } from '@/util/SliderMath';

export default Vue.extend({
    props: {
        value: { type: Number, required: true },
        min: { type: Number, required: true },
        max: { type: Number, required: true },
        techStart: { type: Number, default: Number.MAX_SAFE_INTEGER },
        downTooltip: { type: String, default: '' },
        upTooltip: { type: String, default: '' },
    },
    computed: {
        fillPercent(): string {
            return `${fractionOf(this.value, this.min, this.max) * 100}%`;
        },
        techPercent(): string {
            return `${fractionOf(this.techStart - 1, this.min, this.max) * 100}%`;
        },
        hasTechSegment(): boolean {
            return this.techStart > this.min && this.techStart <= this.max;
        },
    },
});
